import React from "react";

export default ({product}) => {

    return <div className="product-tile insect-page__calendar__product">
        <a href={product.link} className="product-tile__inner insect-page__calendar__product__inner">
            <div className="product-tile__image insect-page__calendar__product__image">
                {!!product.image && <img src={product.image} alt={product.title} /> }
            </div>
            <div className="product-tile__body">
                <h3 className="product-tile__title">{product.title}</h3>
                <div className="product-tile__price insect-page__calendar__product__price">
                    {!!product.previous_price && <span className="insect-page__calendar__product__crossed product-tile__crossed">{product.previous_price}</span>}
                    {!!product.price_applied && <span className="insect-page__calendar__product__selling-price product-tile__selling-price">{product.price_applied}</span>}
                </div>
                {!!product.summary && <p className="product-tile__summary">{product.summary}</p>}
            </div>
        </a>
    </div>;

}
